import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { Controller } from "@commoncore/controller/Controller";
import { FileOperationsImplementation } from "@commoncore/implementation/FileOperationsImplementation";
import { ListViewImplementation } from "@commoncore/implementation/ListViewImplementation";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { AlbumsImplementation } from "../implementation/AlbumsImplementation";

export class AlbumsController extends Controller{
    public albumsImplementation:any;
    public fileOperationsImplementation:any;
    listViewImplementation:any;
    public universalService:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null
    public globalService: any;
    public homeController:any;
    public listService: any;
    public localStorageSvc: any;
    loggerService: any;
    public constructor(globalService) {
      super(globalService);
      this.albumsImplementation= AlbumsImplementation.getInstance(globalService);	
      this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
      this.listViewImplementation= ListViewImplementation.getInstance(globalService);
    }
    
    public static getInstance(globalService):AlbumsController{
		if(this.singleInstance == null){
			this.singleInstance = new AlbumsController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

    public setEnvObjects(globalService){
      this.globalService= globalService
      this.universalService=globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef(); 
      this.listService = globalService.getListServiceRef();
      this.loggerService = globalService.getLoggerServiceRef();
      this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    }

    async fetchAlbumsList(tab){
        this.universalService.showLoader = true;   
        var albumType = "p";
        var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumsList"] + "?page=0&limit=2000";
        if(tab == 'Shared Albums'){
          albumType = 's';
        }
        url = url + '&albumType=' + albumType;
        this.albumsImplementation.setHandler(this.globalService);
        try {
          return await this.albumsImplementation.getAlbumsList(url);
        }catch(exception){
          console.log("expception in fetching albums list",exception);
        } finally{
          this.universalService.showLoader = false;   
        }
        
    }

    async getIndividualAlbumDetails(albumKey){
      var sortOrder = "%2DlastModifiedDate";
      var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumDetails"] + "/"+albumKey + "?page=0&limit=5000&sort=" + sortOrder;
      this.albumsImplementation.setHandler(this.globalService);
      try{
        var result = await this.albumsImplementation.getAlbumDetails(url);
        return Promise.resolve(result);
      }catch(err){
        console.log("expception in fetching albums details",err);
        return Promise.reject(err);
      }
    }

    selectAll(event){
      this.albumsImplementation.selectAll(event)
    }

    async updateUIAfterPerformingAction(list,executedTask){
      var array = [],result;
      if(this.universalService.currentTab == "Favorites"){
        array = this.universalService.objectsPreviewArray;
      }else if(this.albumsImplementation.albumsMetaData.length > 0 ){
        array = this.albumsImplementation.albumsMetaData;
      }
      if(executedTask == 'FTR' || executedTask == 'FRN' || executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV'){
        this.fileOperationsImplementation.setHandler(this.globalService);
        result = await this.fileOperationsImplementation.updateOnlyTheUIWithoutMonthWiseSegregation(array, list,executedTask)
        array = result;
        if(executedTask == 'FTR'){
          result = this.albumsImplementation.deletedList(list)
        }

        await this.albumsImplementation.fetchSingleAlbumObjectList(result,executedTask);
      }else if(executedTask == 'BRN'||executedTask == 'BDU'){
        this.universalService.headingTitle.set(this.universalService.currentAlbum.boardName);
        if(executedTask == 'BRN'){
          
          this.universalService.hideEditAlbumNameBox = true

        }else if(executedTask == 'BDU'){
          this.universalService.hideEditAlbumDescBox = true
        }
        this.universalService.showLoader = false;
        
      }else{
        this.loggerService.log("task invalid",executedTask)

      }

      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
    }

    decideScrollCall(event) {
      this.albumsImplementation.listScrollDown();
    }

    async setAsCoverPic(selectedObject){
      this.universalService.showLoader = true;
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumDetails"] + "/" + this.universalService.currentAlbum["boardKey"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["coverPic"];
      this.albumsImplementation.setHandler(this.globalService);
      try{
        var result = await this.albumsImplementation.setCoverPic(url,selectedObject);
        this.universalService.currentAlbum.boardCoverPicObjectKey = selectedObject.objectKey
        return result
      }catch(err){
        console.log("exception in setting the album cover pic",err);
      }
    }

    async updateAlbumCoverPic(obj){
      this.universalService.showLoader = true;
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG["commonUrls"]["albumDetails"] + "/"  + this.universalService.currentAlbum["boardKey"] + ENV_CONFIG.commonUrls["updateAlbumCoverPic"]; 
      let objectKey = obj.objectKey;
      this.albumsImplementation.setHandler(this.globalService);
      try{
          var result = await this.albumsImplementation.updateAlbumCoverPic(url,objectKey);
          return result
      }catch(exc){
          console.log("exception in update coverpic",exc);
      }
  }
}